import { render, staticRenderFns } from "./card-basic.vue?vue&type=template&id=16053c34&scoped=true&"
import script from "./card-basic.vue?vue&type=script&lang=js&"
export * from "./card-basic.vue?vue&type=script&lang=js&"
import style0 from "./card-basic.vue?vue&type=style&index=0&id=16053c34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16053c34",
  null
  
)

export default component.exports